import script from "./XAllSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./XAllSelect.vue?vue&type=script&lang=ts&setup=true"

import "./XAllSelect.vue?vue&type=style&index=0&id=b589d6a8&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b589d6a8"]])

export default __exports__